"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var ProgramApi = function (_BaseApi) {
  (0, _inherits2["default"])(ProgramApi, _BaseApi);

  function ProgramApi(baseUrl) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var olyEngineApi = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2["default"])(this, ProgramApi);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgramApi).call(this, baseUrl, options, olyEngineApi));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserPrograms", function (_ref) {
      var userId = _ref.userId,
          clientId = _ref.clientId,
          status = _ref.status,
          language = _ref.language,
          limit = _ref.limit,
          next = _ref.next;
      return _this.api.get("/users/".concat(userId, "/programs"), {
        params: {
          clientId: clientId,
          status: status,
          language: language,
          limit: limit,
          next: next
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "joinProgram", function (_ref2) {
      var clientId = _ref2.clientId,
          programId = _ref2.programId,
          userId = _ref2.userId;
      return _this.api.post("/programs/".concat(programId, "/users"), {
        data: {
          userId: userId
        },
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "leaveProgram", function (_ref3) {
      var programId = _ref3.programId,
          userId = _ref3.userId,
          clientId = _ref3.clientId;
      return _this.api["delete"]("/programs/".concat(programId, "/users/").concat(userId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteProgram", function (_ref4) {
      var programId = _ref4.programId,
          clientId = _ref4.clientId;
      return _this.api["delete"]("/programs/".concat(programId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editProgram", function (_ref5) {
      var programId = _ref5.programId,
          program = _ref5.program,
          clientId = _ref5.clientId;
      return _this.api.put("/programs/".concat(programId), {
        data: program,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createProgram", function (_ref6) {
      var program = _ref6.program,
          clientId = _ref6.clientId;
      return _this.api.post('/programs', {
        data: program,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createProgramTag", function (_ref7) {
      var tag = _ref7.tag,
          clientId = _ref7.clientId;
      return _this.api.post('/tags', {
        data: tag,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getProgramTags", function (_ref8) {
      var clientId = _ref8.clientId,
          search = _ref8.search,
          language = _ref8.language;
      return _this.api.get("/tags", {
        params: {
          clientId: clientId,
          search: search,
          language: language
        }
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(ProgramApi, [{
    key: "getProgram",
    value: function getProgram(_ref9) {
      var clientId = _ref9.clientId,
          language = _ref9.language,
          programId = _ref9.programId;
      return this.api.get("/programs/".concat(programId), {
        params: {
          clientId: clientId,
          language: language
        }
      });
    }
  }, {
    key: "getProgramAdmin",
    value: function getProgramAdmin(_ref10) {
      var clientId = _ref10.clientId,
          programId = _ref10.programId;
      return this.api.get("/programs/".concat(programId), {
        params: {
          clientId: clientId
        },
        headers: {
          fromAdmin: true
        }
      });
    }
  }, {
    key: "getPrograms",
    value: function getPrograms(_ref11) {
      var clientId = _ref11.clientId,
          search = _ref11.search,
          language = _ref11.language,
          next = _ref11.next,
          limit = _ref11.limit,
          onlineFilter = _ref11.onlineFilter;
      return this.api.get("/programs", {
        params: {
          clientId: clientId,
          search: search,
          language: language,
          next: next,
          limit: limit,
          onlineFilter: onlineFilter
        }
      });
    }
  }, {
    key: "getProgramsAdmin",
    value: function getProgramsAdmin(_ref12) {
      var clientId = _ref12.clientId,
          search = _ref12.search,
          onlineFilter = _ref12.onlineFilter,
          next = _ref12.next,
          limit = _ref12.limit;
      return this.api.get("/programs", {
        params: {
          clientId: clientId,
          search: search,
          onlineFilter: onlineFilter,
          next: next,
          limit: limit
        },
        headers: {
          fromAdmin: true
        }
      });
    }
  }]);
  return ProgramApi;
}(_createApi.BaseApi);

var _default = ProgramApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map